export const NotificationTypesCodes = Object.freeze({
	confirm: 1,
	simple: 3,
	placeholder: 5,
});